import React from "react";
import MainLayout from "../../../hoc/main";
import {FormContainer, Grid, Input, TextArea} from "../../../components";
import {connect} from "react-redux";
import {editAccessCategoryData, getAccessCategoryData,} from "../../../redux/modules/AccessCategory/action";
import {Button} from "../../../components/Button";
import {Redirect} from "react-router-dom";

class AccessCategoryEdit extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            name: "",
            description: "",
        };
    }

    componentDidMount() {
        this.props.getAccessCategoryData(this.props.match.params.id);
    }

    UNSAFE_componentWillReceiveProps = (np) => {
        this.setState({
            name: np.accessCategory.data.name,
            description: np.accessCategory.data.description,
        });
    };

    onChangeValue = (e) => {
        const {value, name} = e.target;

        this.setState({
            [name]: value,
        });
    };

    finishForm(e) {
        e.preventDefault();
        this.props.editAccessCategoryData(this.props.match.params.id, this.state);
    }

    render() {
        if (this.props.accessCategory?.success) return <Redirect to="/category"/>;
        return (
            <div className="p-6 mt-20 xl:mt-0 ">
                <Grid>
                    <FormContainer className={`pt-0`}>
                        <Input
                            name={"name"}
                            label={"Access category name"}
                            value={this.state.name}
                            placeholder={"Lorem"}
                            className={"w-full md:w-1/2 xl:w-1/3"}
                            onChange={this.onChangeValue}
                        />
                        <TextArea
                            name={"description"}
                            label={"Description"}
                            value={this.state.description}
                            placeholder={"Lorem"}
                            className={"w-full md:w-1/2 xl:w-1/3"}
                            onChange={this.onChangeValue}
                            rows={5}
                        />
                        <hr className={`my-5`}/>
                        <Button
                            className={`bg-green-200 text-green-700`}
                            onClick={this.finishForm.bind(this)}
                        >
                            Submit
                        </Button>
                    </FormContainer>
                </Grid>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    accessCategory: state.accessCategory,
});

const mapDispatchToProps = {
    getAccessCategoryData,
    editAccessCategoryData,
};

export default MainLayout(
    connect(mapStateToProps, mapDispatchToProps)(AccessCategoryEdit)
);
